import React, { Component } from 'react';
import * as IFrame from 'react-iframe-form';
import API from '../../utils/API';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from 'reactstrap';

import fileIcon from '../../assets/img/icons/file.png';
const ENV =
    process.env.NODE_ENV === 'production'
        ? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;
class FileListLayout extends Component {
    constructor(props) {
        super(props);
        this.sidebarScroll = React.createRef();
        this.contentScroll = React.createRef();
        this._preventEvent = false;
        this.contentLastScrollTop = 0;
        this.contentLastScrollLeft = 0;

        this.state = {
            hoverIndex: null,
            selectedMenu: null,
            lastCheckedIndex: null,
            copyText: "Copy Link",
        };
    }

    onSidebarScroll = (e) => {
        if (this._preventEvent) {
            this._preventEvent = false;
            return;
        }

        this._preventEvent = true;
        this.contentScroll.current.scrollTop = e.target.scrollTop;
    };

    onContentScroll = (e) => {
        if (this._preventEvent) {
            this._preventEvent = false;
            return;
        }

        if (e.target.scrollTop !== this.contentLastScrollTop) {
            this._preventEvent = true;
            this.sidebarScroll.current.scrollTop = e.target.scrollTop;
            this.contentLastScrollTop = e.target.scrollTop;
        }
    };

    toggleFavorite = (fileId, set) => {
        const { orgId, updateFavorite } = this.props;


        API().post(`Organizations/${orgId}/platformActions/favorite`, { type: 'file', id: fileId, set: set }).then((res) => {


            updateFavorite(fileId, set);
        });

    }

    dropDownIsOpen = () => {
        const { dropDownIsOpen } = this.state
        this.setState({ dropDownIsOpen: !dropDownIsOpen })
    }


    GridFileItem(file, index) {
        const { checked, checkRow, singleSelection, isiFrame, eventId, orgId, isRemoveEllipses, isOpen, toggle } = this.props;
        const { selectedMenu, copyText, dropDownIsOpen } = this.state;
        let url = `${ENV}Organizations/${orgId}/events/${eventId}/templates/${file._id}/render`;
        let method = 'post';
        let data = { html: file.html };

        let imageDimensions = '';

        if (file.type.includes('image')) {

            imageDimensions = file.dimensions


        }

        return (
            <div
                className={`fileListLayoutItem ${checked[file._id] ? 'selected' : ''}`}>
                <div>
                    <div
                        className='imageContainer'
                    >
                        <div className='selectContainer'>


                            <div
                                className={`checkBoxContainer checkBox ${checked[file._id] ? 'checked' : ''}`}
                                disable={singleSelection && Object.keys(checked).length > 0 && !checked[file._id]}
                                onClick={() => {
                                    if (!(singleSelection && Object.keys(checked).length > 0 && !checked[file._id])) {

                                        const checkedLength = Object.keys(checked).length;
                                        if (singleSelection) {
                                            if (!checked[file._id] && checkedLength == 0) {
                                                checkRow(file._id);
                                            } else if (checked[file._id] && checkedLength == 1) {
                                                checkRow(file._id);
                                            }
                                        } else {
                                            checkRow(file._id);
                                        }
                                    }
                                }
                                }
                            >
                                <i className="las la-check" />
                            </div>

                            <div className='c-pointer favoriteContainer'
                                onClick={() => {
                                    this.toggleFavorite(file._id, !file.isFavorite);
                                }}
                            >
                                {file.isFavorite ? <i className="isFavorite las la-star"></i>
                                    :
                                    <i className="lar la-star"></i>
                                }

                            </div>
                        </div>
                        <img
                            className="image"
                            title={`${file.name}`}
                            src={file.type.includes('image') ? file.url : fileIcon}
                        />

                    </div>

                </div>

                <div className='imageDetailsContainer'>
                    <div className='fileName'>
                        {file.name}
                    </div>
                    <div className='detailsContainer'>
                        <Dropdown direction="right" isOpen={dropDownIsOpen == file._id}
                            toggle={() => {
                                if ((dropDownIsOpen !== file._id)) {
                                    this.setState({ dropDownIsOpen: file._id })
                                }
                                else {
                                    this.setState({ dropDownIsOpen: "" });
                                }
                            }}>

                            <DropdownToggle className="columnToggle">
                                <div className='icon'>
                                    <i className="las la-ellipsis-v" />
                                </div>
                            </DropdownToggle>
                            <DropdownMenu className="columnDropdown" style={{ minWidth: 230 }}>
                                <div className='ph-20'>
                                    <DropdownItem
                                        className={`moreViewsPopoverItemMenuItem`}
                                        style={{ textTransform: 'capitalize', padding: '7px 10px' }}
                                        onClick={() => {
                                            this.toggleFavorite(file._id, !file.isFavorite);
                                        }}
                                    >
                                        {file.isFavorite ? <i className="mr-10 isFavorite las la-star"></i>
                                            :
                                            <i className="lar la-star mr-10"></i>
                                        } Favorite
                                    </DropdownItem>

                                    <DropdownItem
                                        className={`moreViewsPopoverItemMenuItem`}
                                        style={{ textTransform: 'capitalize', padding: '7px 10px' }}

                                        onClick={async () => {
                                            navigator.clipboard.writeText(file.url).then(

                                                () => {
                                                    this.setState({ copyText: "Link Copied" }, () => {
                                                        setTimeout(() => {
                                                            this.setState({ copyText: "Copy Link" })
                                                        }, 2000)
                                                    })

                                                },
                                                () => {
                                                    document.execCommand('copy', true, file.url);
                                                    this.setState({ copyText: "Link Copied" }, () => {
                                                        setTimeout(() => {
                                                            this.setState({ copyText: "Copy Link" })
                                                        }, 2000)
                                                    })


                                                }
                                            );
                                        }}
                                    >
                                        <div>
                                            <i className="las la-link mr-10"></i>

                                            {copyText}
                                        </div>


                                    </DropdownItem>


                                </div>
                                <hr />



                                <div className='ph-20'>
                                    <div className="mb-10" style={{ fontWeight: 600 }}>File Details</div>

                                    <div className="mb-10">
                                        <div style={{ fontSize: 12, color: '#999999' }}>Type:</div>
                                        <div>{file.type}</div>
                                    </div>

                                    <div className="mb-10">
                                        <div style={{ fontSize: 12, color: '#999999' }}>Size:</div>
                                        <div>{file.size}</div>
                                    </div>

                                    <div className="mb-10">
                                        <div style={{ fontSize: 12, color: '#999999' }}>Modified:</div>
                                        <div>{moment(file.updatedAt).format('MMMM Do YYYY, h:mm A')}</div>
                                    </div>

                                    <div className="mb-10">
                                        <div style={{ fontSize: 12, color: '#999999' }}>Created:</div>
                                        <div>{moment(file.createdAt).format('MMMM Do YYYY, h:mm A')}</div>
                                    </div>

                                </div>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>

                <div
                    className='dimensions'>
                    {imageDimensions}
                </div>
            </div >
        );
    }

    shiftCheck = (id, index) => {
        const { data, checked, checkRow } = this.props;
        const keys = Object.keys(checked);
        var checkedLength = keys.length;

        if (checkedLength == 0) {
            for (var i = 0; i <= index; i++) {

                checkRow(data[i]._id);
            }
            this.setState({ lastCheckedIndex: index });
        } else {
            let from = this.state.lastCheckedIndex > index ? index : this.state.lastCheckedIndex;
            let to = this.state.lastCheckedIndex < index ? index : this.state.lastCheckedIndex;
            if (keys.includes(id)) {
                for (var i = from; i <= to; i++) {
                    checked[data[i]._id] && checkRow(data[i]._id);
                }
            } else {
                for (var i = from; i <= to; i++) {
                    !checked[data[i]._id] && checkRow(data[i]._id);
                }
            }
            this.setState({ lastCheckedIndex: index });
        }
    };

    RowItem(meta, index) {
        const { columns, toggledColumns, checked, checkRow, onClick, singleSelection, isiFrame, dropDownisOpen } = this.props;
        const { hoverIndex, copyText, dropDownIsOpen } = this.state;

        return (
            <div
                key={`row-${meta._id}`}
                className={`tableColumnRow ${hoverIndex == index ? 'hover' : ''} ${checked[meta._id]
                    ? 'checked'
                    : ''} ${onClick ? 'c-pointer' : ''}`}
            >
                {columns.map((c, i) => {
                    let value = '';
                    if (typeof meta[c.key] != 'undefined' && meta[c.key] != null) {
                        if (typeof meta[c.key] == 'boolean') {
                            value = meta[c.key] ? 'Yes' : 'No';
                        } else if (c.type == 'date') {
                            value = moment(meta[c.key]).format('MM/DD/YYYY');
                        } else if (c.type == 'timestamp') {
                            value = moment(meta[c.key]).format('MM/DD/YYYY h:mm a');
                        } else if (c.type == 'time') {
                            const today = moment().format('YYYY-MM-DD');
                            value = moment(`${today} ${meta[c.key]}`).format('h:mm a');
                        } else if (c.type == 'link') {
                            value = (
                                <a className="link" href={meta[c.key]} target="_blank">
                                    {meta[c.key]}
                                </a>
                            );
                        } else if (c.type == 'bool') {
                            value = meta[c.key] ? 'Yes' : 'No';
                        } else {
                            value = meta[c.key];
                        }
                    }

                    return (
                        toggledColumns[c.key] && (
                            <div
                                style={{
                                    maxWidth: i == 0 ? '500px' : '180px',
                                    minWidth: i == 0 ? '500px' : '180px',
                                    opacity:
                                        singleSelection && Object.keys(checked).length > 0 && !checked[meta._id]
                                            ? '0.3'
                                            : '1'
                                }}
                                className="tableColumnRowCell text-truncate calibreRegular"
                                key={`cell-${c.key}`}
                            >
                                {i == 0 && (
                                    <div
                                        style={{ marginTop: 'auto', marginBottom: 'auto' }}
                                        className={`checkBox mr-10 ${checked[meta._id] ? 'checked' : ''}`}
                                        onClick={(e) => {
                                            const checkedLength = Object.keys(checked).length;
                                            if (singleSelection) {
                                                if (!checked[meta._id] && checkedLength == 0) {
                                                    checkRow(meta._id);
                                                } else if (checked[meta._id] && checkedLength == 1) {
                                                    checkRow(meta._id);
                                                }
                                            } else {
                                                if (e.shiftKey) {
                                                    this.shiftCheck(meta._id, index);
                                                } else {
                                                    this.setState({ lastCheckedIndex: i });
                                                    checkRow(meta._id);
                                                }

                                            }
                                        }}
                                    >
                                        <i className="las la-check" />
                                    </div>
                                )}
                                {meta.link ? (
                                    <Link to={meta.link} style={{ color: '#000' }}>
                                        <div
                                            style={{ display: 'flex', alignItems: 'center' }}
                                            onClick={() => {
                                                if (onClick) {
                                                    onClick(meta._id);
                                                }
                                            }}
                                        >
                                            {i == 0 && (
                                                <div>
                                                    {!isiFrame && (
                                                        <img
                                                            style={{
                                                                width: 34,
                                                                height: 34,
                                                                padding: '5px 10px 5px 0px'
                                                            }}
                                                            src={meta.type.includes('image') ? meta.url : fileIcon}
                                                            alt="none"
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            <div style={{ height: 16 }}>{value}</div>
                                        </div>
                                    </Link>
                                ) : (
                                    <div
                                        style={{ display: 'flex', alignItems: 'center' }}
                                        onClick={() => {
                                            if (onClick) {
                                                onClick(meta._id);
                                            }
                                        }}
                                    >
                                        {i == 0 && (
                                            <div>
                                                {!isiFrame && (

                                                    < div
                                                        className='rowImage'>
                                                        {/* <img
                                                        style={{
                                                            width: 34,
                                                            height: 34,
                                                            padding: '5px 10px 5px 0px'
                                                        }}
                                                        src={meta.type.includes('image') ? meta.url : fileIcon}
                                                        alt="none"
                                                    /> */}
                                                        <img
                                                            className="image"
                                                            title={`${meta.name}`}
                                                            src={meta.type.includes('image') ? meta.url : fileIcon}
                                                        />

                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div >{value}</div>
                                    </div>
                                )}
                            </div>
                        )
                    );
                })}
                <div className='detailsContainer' style={{ marginLeft: 'auto', paddingRight: 60 }}>
                    <Dropdown direction="left" inNavbar isOpen={dropDownIsOpen == meta._id}
                        toggle={() => {
                            if ((dropDownIsOpen !== meta._id)) {
                                this.setState({ dropDownIsOpen: meta._id })
                            }
                            else {
                                this.setState({ dropDownIsOpen: "" })
                            }
                        }}>
                        <DropdownToggle className="columnToggle " style={{ width: 30, height: 30 }}>
                            <div className='icon '>
                                <i className="las la-ellipsis-v" />
                            </div>
                        </DropdownToggle>
                        <DropdownMenu className="columnDropdown" style={{ minWidth: 230 }}>
                            <div className='ph-20'>


                                <DropdownItem
                                    className={`moreViewsPopoverItemMenuItem`}
                                    style={{ textTransform: 'capitalize', padding: '7px 10px' }}
                                    onClick={() => {
                                        this.toggleFavorite(meta._id, !meta.isFavorite);
                                    }}
                                >

                                    {meta.isFavorite ? <i className="mr-10 isFavorite las la-star"></i>
                                        :
                                        <i className="lar la-star mr-10"></i>
                                    } Favorite
                                </DropdownItem>
                                <DropdownItem
                                    className={`moreViewsPopoverItemMenuItem`}
                                    style={{ textTransform: 'capitalize', padding: '7px 10px' }}
                                    onClick={async () => {
                                        navigator.clipboard.writeText(meta.url).then(

                                            () => {
                                                this.setState({ copyText: "Link Copied" }, () => {
                                                    setTimeout(() => {
                                                        this.setState({ copyText: "Copy Link" })
                                                    }, 2000)
                                                })

                                            },
                                            () => {

                                                document.execCommand('copy', true, meta.url);
                                                this.setState({ copyText: "Link Copied" }, () => {
                                                    setTimeout(() => {
                                                        this.setState({ copyText: "Copy Link" })
                                                    }, 2000)
                                                })
                                            }
                                        );
                                    }}
                                >

                                    <i className="las la-link mr-10"></i>
                                    {copyText}
                                </DropdownItem>


                            </div>
                            <hr />



                            <div className='ph-20'>
                                <div className="mb-10" style={{ fontWeight: 600 }}>File Details</div>

                                <div className="mb-10">
                                    <div style={{ fontSize: 12, color: '#999999' }}>Type:</div>
                                    <div>{meta.type}</div>
                                </div>

                                <div className="mb-10">
                                    <div style={{ fontSize: 12, color: '#999999' }}>Size:</div>
                                    <div>{meta.size}</div>
                                </div>

                                <div className="mb-10">
                                    <div style={{ fontSize: 12, color: '#999999' }}>Modified:</div>
                                    <div>{moment(meta.updatedAt).format('MMMM Do YYYY, h:mm A')}</div>
                                </div>

                                <div className="mb-10">
                                    <div style={{ fontSize: 12, color: '#999999' }}>Created:</div>
                                    <div>{moment(meta.createdAt).format('MMMM Do YYYY, h:mm A')}</div>
                                </div>

                            </div>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        );
    }

    mouseHoverStart = (index) => {
        this.setState({ hoverIndex: index });
    };

    mouseHoverEnd = () => {
        this.setState({ hoverIndex: null });
    };

    render() {
        const {
            readOnly,
            mainColumnActive,
            toggledColumns,
            checked,
            checkRow,
            checkAllRows,
            data,
            sortData,
            columns,
            isGridLayout,
            sortByColumn,
            singleSelection
        } = this.props;
        const { hoverIndex } = this.state;
        const mainColumn = columns[0];
        const allChecked = data.length === Object.keys(checked).length && Object.keys(checked).length > 0;

        return !isGridLayout ? (
            <div className="sectionTable" style={this.props.style}>
                <div className="tableSubColumns">
                    <div className="tableColumnHeader">
                        {columns.map(
                            (c, i) =>
                                toggledColumns[c.key] && (
                                    <div
                                        className="tableSubColumn"
                                        style={{
                                            maxWidth: i == 0 ? '500px' : '180px',
                                            minWidth: i == 0 ? '500px' : '180px'
                                        }}
                                        onClick={() => {
                                            if (c.sortAsc) {
                                                sortData(c, false, true);
                                            } else {
                                                sortData(c, true, false);
                                            }
                                        }}
                                    >
                                        {i == 0 &&
                                            !singleSelection && (
                                                <div
                                                    className={`checkBox mr-10 ${allChecked ? 'checked' : ''}`}
                                                    onClick={() => checkAllRows(allChecked ? [] : data.map((sd) => sd._id))}
                                                >
                                                    <i className="las la-check" />
                                                </div>
                                            )}
                                        <div className="tableColumnTitle2" title={c.label}>
                                            {c.label}
                                            {c.sortAsc ? (
                                                <i className="las la-angle-down" />
                                            ) : c.sortDesc ? (
                                                <i className="las la-angle-up" />
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                )
                        )}
                    </div>
                    <div className="tableColumnRows w-fc">{data.map((d, i) => this.RowItem(d, i))}

                        {data.length == 0 ?
                            <div className='BlankTable'>
                                <h2 className='mb-15'> No {this.props.title} Yet</h2>

                                <p className='tableLabel'> Add <span className='lower' > {this.props.title} </span>{this.props.importAvailable && <span> or import <span className='lower'> {this.props.title} </span>  from a spreadsheet. </span>} </p>
                            </div>
                            : false
                        }
                    </div>
                </div>
            </div>
        ) : (
            <div style={{ overflow: 'auto', height: '100%' }}>
                <div className="tableSubColumns" style={{ height: '100%', overflowX: 'hidden' }}>
                    {/*  <div className="tableColumnHeader">
                        {columns.map(
                            (c, i) =>
                                toggledColumns[c.key] &&
                                i == 0 && (
                                    <div
                                        className="tableSubColumn"
                                        onClick={() => {
                                            if (c.sortAsc) {
                                                sortData(c, false, true);
                                            } else {
                                                sortData(c, true, false);
                                            }
                                        }}
                                    >
                                        {i == 0 &&
                                            !singleSelection && (
                                                <div
                                                    className={`checkBox mr-10 ${allChecked ? 'checked' : ''}`}
                                                    onClick={() => checkAllRows(allChecked ? [] : data.map((sd) => sd._id))}
                                                >
                                                    <i className="las la-check" />
                                                </div>
                                            )}
                                        <div className="tableColumnTitle2" title={c.label}>
                                            {c.label}
                                            {c.sortAsc ? (
                                                <i className="las la-angle-down" />
                                            ) : c.sortDesc ? (
                                                <i className="las la-angle-up" />
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                )
                        )}
                    </div> */}
                    <div
                        style={{ display: 'flex', flexFlow: 'wrap', flexGrow: 'unset', height: '100%', alignContent: 'baseline' }}
                        className="tableColumnRows w-fc"
                        ref={this.contentScroll}
                    >
                        {data.map((d, i) => this.GridFileItem(d, i))}

                        {data.length == 0 ?
                            <div className='BlankTable'>
                                <h2 className='mb-15'> No {this.props.title} Yet</h2>

                                <p className='tableLabel'> Add <span className='lower' > {this.props.title} </span>{this.props.importAvailable && <span> or import <span className='lower'> {this.props.title} </span>  from a spreadsheet. </span>} </p>
                            </div>
                            : false
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default FileListLayout;
